import endpoint from "../../features/endPoints/ecommEndpoints";
import BaseClient from "../base/baseClient";

import store from "../../../reduxStore/store";
import {
  setDisplayEasyPayButton,
  setDisplayPrePayButton,
  setAccountDetailsCacheTimeStampValue,
} from "../../../reduxStore/myAccount/accountSummarySlice";
import { encryptData } from "../../utils/hashing";
import Storage from "../../features/helpers/storageHelper";

const timeout = JSON.parse(process.env.REACT_APP_ECOMM_TIMEOUT_SEC) * 1000;
var _accountDetailsPromise = null; // to ensure call is made only once on a page
let currentController = null;

const accountDetails = async (customerNumber, serviceAddress, apiAbortSignal = null, addrID = null) => {
  let bypassCache = store.getState().accountSummary.bypassAccountDetailsCache;
  let apiCallFlag = store.getState().accountSummary.callAccountDetailsApi;

  if (apiCallFlag === "true") {
    _accountDetailsPromise = null;
  }

  if (
    _accountDetailsPromise &&
    bypassCache === "false" &&
    apiCallFlag === "false"
  )
    return _accountDetailsPromise;

  const newTimeStampValue =
    new Date().getTime().toString() + Math.floor(Math.random() * 1000000);
  if (bypassCache === "true") {
    store.dispatch(setAccountDetailsCacheTimeStampValue(newTimeStampValue));
  }

  const bypassCacheHeaderValue =
    bypassCache === true
      ? newTimeStampValue
      : store.getState().accountSummary.accountDetailsCacheTimeStampValue;

  const { post: postClient } = BaseClient();
  try {
    const requestBody = mapRequest(customerNumber, serviceAddress);

    if(addrID !== null) {
      requestBody.addressID = addrID;
    }
    else if(document.getElementById("serviceAddressSelect")){
      addrID = document.getElementById("serviceAddressSelect")?.value?.split(" | ")?.[2] || "";
      
      if(addrID !== "" && addrID !== null && addrID !== undefined && addrID !== "undefined")
        requestBody.addressID = parseInt(addrID);
    }

    let options = { timeout, headers: { "bypass-cache": bypassCacheHeaderValue } };

    let signal = null;
    if(apiAbortSignal !== null){
        options.signal = apiAbortSignal;
    } else {
    
      if (currentController) {
          currentController.abort();
      }

      let controller = new AbortController();
      currentController = controller;
      signal = controller.signal;
      options.signal = signal;
    }
    
    const response = await postClient(
      process.env.REACT_APP_ECOMM_URL + endpoint.getAccountDetails(),
      requestBody,
      options,
      true
    );
    currentController = null;
    const setPayButton = mapResponse(true);
    return setPayButton(response);
  } catch (error) {
    return {
      error: "Some error occured in accountDetails api. Please try again",
    };
  }
};

const allAccountDetails = async (customerNumber) => {
  let bypassCache = store.getState().accountSummary.bypassAccountDetailsCache;

  const newTimeStampValue =
    new Date().getTime().toString() + Math.floor(Math.random() * 1000000);
  if (bypassCache === true) {
    store.dispatch(setAccountDetailsCacheTimeStampValue(newTimeStampValue));
  }

  const bypassCacheHeaderValue =
    localStorage.getItem("accountDetailsCacheTimeStampValue") != null
      ? localStorage.getItem("accountDetailsCacheTimeStampValue")
      : "555555";

  const { post: postClient } = BaseClient();
  try {
    const requestBody = mapRequest(customerNumber, "");
    const response = await postClient(
      process.env.REACT_APP_ECOMM_URL + endpoint.getAccountDetails(),
      requestBody,
      { timeout, headers: { "bypass-cache": bypassCacheHeaderValue } },
      true
    );
    const setPayButton = mapResponse(true);
    return setPayButton(response);
  } catch (error) {
    return { error: "Some error occured accountDetails api. Please try again" };
  }
};

//map body to request body as per API
const mapRequest = (customerNumber, serviceAddress) => {

  const customerInfo = store.getState().login.customerInfo;
  const selAdd = store.getState().accountSummary.selectedServiceAddress;

  let cusNumber = null;
  if(selAdd !== null && serviceAddress === undefined){
    [serviceAddress, cusNumber] = selAdd.split(" | ");
  }

  customerNumber = document.getElementById("serviceAddressSelect")?.value?.split(" | ")?.[1] || customerNumber;

  serviceAddress = document.getElementById("serviceAddressSelect")?.value?.split(" | ")?.[0] || serviceAddress;

  let addressID = null;
  if(customerInfo && customerInfo.length > 0){
    for(const customer of customerInfo) {
      if(customer.CustomerNumber === customerNumber){

        if(customer.ServiceAddresses && customer.ServiceAddresses.length > 0){
          for(const srvcAddress of customer.ServiceAddresses) {
            if(srvcAddress.address === serviceAddress){
              addressID = srvcAddress.addressId;
              break;
            }
          }
        }
        if(addressID !== null){
          break;
        }
      }
    }
  }

  customerNumber =
    typeof customerNumber === "undefined"
      ? Storage.customerNumber()
      : customerNumber;
  serviceAddress =
    typeof serviceAddress === "undefined"
      ? Storage.serviceAddress()
      : serviceAddress;

  customerNumber =
    process.env.REACT_APP_CUSLOC_ENABLE === "true"
      ? `${customerNumber}__customervalue${Date.now()}`
      : customerNumber;

  return {
    CustomerNumber: encryptData(customerNumber, "customerNumber"),
    svcAddressLine1: serviceAddress,
    addressID: addressID
  };
};

const mapResponse = (setPayButton) => (response) => {
  const responseBody = response.data;
  const retCode = response.statusText;
  const resStatus = response.status;

  if (retCode === "OK" || resStatus === 200) {
    if (setPayButton) {
      _setPayButtonsStatus(responseBody);
    }
    return responseBody;
  }

  return mapError(response);
};

//map error to object needed by React view
const mapError = (response) => {
  const { formatError } = BaseClient();
  let error = response?.error !== "signal is aborted without reason" ? "Some error occurred." : response?.error;
  return formatError(
    response,
    error
  );
};

const _setPayButtonsStatus = (accountSummary) => {
  if (!accountSummary.SalesAgreementVer5PPEPList) return;

  let customerNumber = Storage.customerNumber();
  let serviceAddress = Storage.serviceAddress();

  customerNumber = document.getElementById("serviceAddressSelect")?.value?.split(" | ")?.[1] || customerNumber;

  serviceAddress = document.getElementById("serviceAddressSelect")?.value?.split(" | ")?.[0] || serviceAddress;

  const salesAgreementVer5PPEP =
    accountSummary.SalesAgreementVer5PPEPList.filter(
      (salesAgreementVList) =>
        salesAgreementVList.cusNum === customerNumber &&
        salesAgreementVList.saAddress === serviceAddress
    )[0];
  if (!salesAgreementVer5PPEP) return;

  store.dispatch(setDisplayPrePayButton(salesAgreementVer5PPEP.dspPPSignupButton === "Y"));
  store.dispatch(setDisplayEasyPayButton(salesAgreementVer5PPEP.dspEPSignupButton === "Y"));

  Storage.displayPayButtons({
    prePay: salesAgreementVer5PPEP.dspPPSignupButton === "Y",
    easyPay: salesAgreementVer5PPEP.dspEPSignupButton === "Y",
  });
};

export default accountDetails;

export { allAccountDetails as AllAccountDetailsClient };
